import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'root/view/base';
import Constants from 'root/constants';

var Webhook = View.extend({
    className: 'box-medium box-integration',

    events: {
        'click .activate:not(.disabled)'   : 'activate',
        'click .deactivate:not(.disabled)' : 'deactivate',
        'click .settings:not(.disabled)'   : 'editSettings',
        'click .test:not(.disabled)'       : 'test'
    },

    dom_handlers: {
        activate: function(e) {
            if (!Cache.account.hasFeature('webhook') || Cache.account.get('is_expired')) {
                Modals.unlockFeature('Upgrade your plan to start using Integrations.');
            } else {
                Modals.activateWebhook();
            }
        },

        deactivate: function(e) {
            Modals.deactivateWebhook();
        },

        editSettings: function(e) {
            Modals.editWebhook();
        },

        test: function(e) {
            this.$el.addClass('testing');

            Cache.app.request({
                action: 'integration/testWebhook',
                context: this,
                success: function() {
                    UI.success('Test data sent to your webhook succesfully');
                },
                complete: function() {
                    this.$el.removeClass('testing');
                }
            });
        }
    },

    event_handlers: {
        onConnect: function(model) {
            if (model.get('project_id') !== Cache.default_project_id) {
                return;
            }

            this.model = model;
            this.render();
        },

        onDisconnect: function(model) {
            if (model.get('project_id') !== Cache.default_project_id) {
                return;
            }

            this.model = undefined;
            this.render();
        }
    },

    initialize: function(options) {
        this.model = Cache.integration_webhook.findWhere({project_id: Cache.default_project_id});

        this.listenTo(Cache.integration_webhook, 'change', this.render);
        this.listenTo(Cache.integration_webhook, 'add',    this.event_handlers.onConnect);
        this.listenTo(Cache.integration_webhook, 'remove', this.event_handlers.onDisconnect);
    },

    isConnected: function() {
        return this.model && this.model.isConnected() ? true : false;
    },

    isUpgrade: function() {
        if (!this.isConnected()) {
            return false;
        }

        var webhook_url = this.model.get('webhook_url');
        var event_type  = this.model.get('event_type')

        return webhook_url && event_type.length === 1 && event_type[0] === Constants.WEBHOOK_EVENT_FEEDBACK_ADD_OLD;
    },

    render: function() {
        var content = '';

        content += '<div class="thumbnail">' +
                        '<img src="/image/webhook_small.png">' +
                    '</div>' +
                    '<div class="content">' +
                        '<h3>Webhook' +
                        (this.isConnected() ? '<span class="badge-success-invert badge-small">Active</span>' : '') +
                        (this.isUpgrade() ? '<span class="badge-warning-invert badge-small">Update required</span>' : '' ) +
                        '</h3>' +
                        '<div>Use webhook to notify your app or web application when certain events occur in Userback.</div>' +
                    '</div>' +
                    (this.isConnected() ?

                    (Cache.app.isAdmin() ?
                    '<div class="action">' +
                        '<div class="button-dropdown">' +
                            '<button class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown">' +
                                    '<li class="deactivate">Disconnect</li>' +
                                    '<li class="test">Test</li>' +
                                    '<li class="separator"></li>' +
                                    '<li class="settings">Settings</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' : '')

                    :

                    '<div class="action"><button type="button" class="activate small tertiary min">Connect</button></div>');

        this.$el.html(content);

        this.$el.toggleClass('connected', this.isConnected());

        return this;
    }
});

export default Webhook;